export function empty(el: HTMLElement): HTMLElement {
  while (el.lastChild) {
    el.removeChild(el.lastChild)
  }
  return el
}
